import type de from "./de-locale";
import { headers } from "~/i18n/en/infoPages/headers";
import { intro_page } from "~/i18n/en/infoPages/introPage";
import { vision_page } from "~/i18n/en/infoPages/visionPage";
import { team_mode } from "~/i18n/en/teamMode";
import { team_page } from "~/i18n/en/infoPages/teamMembers";
import { faq_page } from "~/i18n/en/infoPages/faq";
import { laws } from "~/i18n/en/infoPages/laws";
import { data_protection as data_privacy } from "~/i18n/en/infoPages/dataProtection";
import { imprint } from "~/i18n/en/infoPages/imprint";
import { terms_and_conditions } from "~/i18n/en/infoPages/termsAndConditions";
import { feedback_form } from "~/i18n/en/feedback_form";
import { onboardingTour } from "~/i18n/en/onboardingTour";
import { cookies } from "~/i18n/en/cookies";
import { ui } from "~/i18n/en/ui";
import { authentication } from "~/i18n/en/authentication";
import { bookshelf } from "~/i18n/en/bookshelf";
import { entries } from "~/i18n/en/entries";
import { legal_text } from "~/i18n/en/legalText";
import { settings } from "~/i18n/en/settings";
import { colors } from "~/i18n/en/colors";
import { redirects } from "~/i18n/en/redirects";

const en: typeof de = {
  authentication,
  ui,
  settings,
  dot: ".",
  comma: ",",
  library: "Library",
  workspace: "Workspace",
  info_site: "Info Pages",
  misc: "Misc.",
  intro: "Intro",
  tour: "Tour",
  document: "Document",
  documents: "Documents",
  schema: "Document",
  schemata: "Documents",
  feedback: "Feedback",
  offline: "You are offline",
  eraser: "Eraser",
  eraser_help_text: "Delete: Click on personalization.",
  main_search_placeholder: "Search for paragraphs, statutes or keyword",
  updates: "Updates",
  subscribe: "Subscribe",
  cancel: "Cancel",
  apply_changes: "Apply Changes",
  bookshelf,
  entries,
  team_mode,
  feedback_form,
  cookies,
  legal_text,
  onboardingTour,
  info_pages: {
    headers,
    intro_page,
    vision_page,
    team_page,
    faq_page,
    terms_and_conditions,
    data_privacy,
    imprint,
    laws,
  },
  colors,
  redirects,
};

export default en;
